module.exports = __webpack_public_path__ + "static/media/temp_chart3.c711ec5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/colonyGame/temp_chart3.png
// module id = 2281
// module chunks = 0